// Served from the frontend's own static assets (public/silhouettes/), not the
// API. These are placeholder UI art shown when an item has no thumbnail — the
// backend no longer exposes an unauthenticated /api/videos static mount (N-152).
const SALSA_SILHOUETTES = Array.from({ length: 16 }, (_, i) => {
  const num = String(i + 1).padStart(2, '0');
  return `/silhouettes/salsa-silhouette-${num}.webp`;
});

export function getRandomSilhouette(): string {
  return SALSA_SILHOUETTES[Math.floor(Math.random() * SALSA_SILHOUETTES.length)];
}

export default SALSA_SILHOUETTES;
